var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"d-flex flex-column align-items-center"},[_c('IconTrinity',{staticClass:"py-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }